export var DEFAULT_RUS_PLAYER = {
    // TODO: move from this file
    Ranger: "Греф",
    Player: "Греф",
    FromPlanet: "Земля",
    FromStar: "Солнечная",
    ToPlanet: "Боннасис",
    ToStar: "Процион",
    Money: "10000",
    lang: "rus",
    allowBackButton: false,
};
export var DEFAULT_ENG_PLAYER = {
    // TODO: move from this file
    Ranger: "Ranger",
    Player: "Player",
    FromPlanet: "FromPlanet",
    FromStar: "FromStar",
    ToPlanet: "ToPlanet",
    ToStar: "ToStar",
    Money: "10000",
    lang: "eng",
    allowBackButton: false,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxheWVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicGxheWVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCQSxNQUFNLENBQUMsSUFBTSxrQkFBa0IsR0FBVztJQUN4Qyw0QkFBNEI7SUFDNUIsTUFBTSxFQUFFLE1BQU07SUFDZCxNQUFNLEVBQUUsTUFBTTtJQUNkLFVBQVUsRUFBRSxPQUFPO0lBQ25CLFFBQVEsRUFBRSxXQUFXO0lBQ3JCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLEtBQUssRUFBRSxPQUFPO0lBRWQsSUFBSSxFQUFFLEtBQUs7SUFDWCxlQUFlLEVBQUUsS0FBSztDQUN2QixDQUFDO0FBQ0YsTUFBTSxDQUFDLElBQU0sa0JBQWtCLEdBQVc7SUFDeEMsNEJBQTRCO0lBQzVCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLEtBQUssRUFBRSxPQUFPO0lBRWQsSUFBSSxFQUFFLEtBQUs7SUFDWCxlQUFlLEVBQUUsS0FBSztDQUN2QixDQUFDIn0=